import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getProjectTasks } from 'api/backlogList'

export const getProjectTasksAction = createAsyncThunk(
  'backlogList/getProjectTasks',
  async (data, { rejectWithValue }) => {
    const isStringPayload = typeof data === 'string'

    const response = await getProjectTasks(
      isStringPayload ? data : data.slug,
      data,
      data.controller
    )

    if ((response?.status || response?.code) >= 400) {
      return rejectWithValue({
        status: response?.status || response?.code,
        message: response?.data?.message || response?.errorMessage,
        data: response?.data || null,
      })
    }

    return response
  }
)

const backlogListSlice = createSlice({
  name: 'backlogList',
  initialState: {
    getProjectTaskStatus: 'idle',
    tasks: [],
    meta: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProjectTasksAction.pending, (state) => {
        state.getProjectTaskStatus = 'pending'
        state.error = null
      })
      .addCase(getProjectTasksAction.fulfilled, (state, action) => {
        state.getProjectTaskStatus = 'success'
        state.tasks = Array.isArray(action.payload?.data)
          ? action.payload.data
          : []
        state.meta = action.payload?.meta || null
        state.error = null
      })
      .addCase(getProjectTasksAction.rejected, (state, action) => {
        state.getProjectTaskStatus = 'error'
        state.tasks = []
        state.meta = null
        state.error = action.payload || null
      })
  },
})

export const backlogListSelector = (state) => state.backlogList.tasks
export const backlogListMetaSelector = (state) => state.backlogList.meta
export const backlogListStatusSelector = (state) =>
  state.backlogList.getProjectTaskStatus
export const backlogListErrorSelector = (state) => state.backlogList.error

export default backlogListSlice.reducer
